<template>
  <QPage>
    <div />
  </QPage>
</template>

<script>
import { LoadingManager } from "@core/managers/loading.manager";
import { ETAB_ROUTES } from "@etab/config";
import { INITIAL_LOADING_DELAY } from "@core/constants";

let timer;

export default {
  created() {
    LoadingManager.show();
  },
  mounted() {
    // place a timer in order to give the app the time it needs to start correctly
    timer = setTimeout(() => {
      LoadingManager.hide();
      this.navigateAway();
    }, INITIAL_LOADING_DELAY);
  },
  beforeUnmount() {
    clearTimeout(timer);
  },
  methods: {
    navigateAway() {
      return this.$router.replace({ name: ETAB_ROUTES.smartRedirect.name }).catch(suppressedError => {});
    },
  },
};
</script>
